import GiftYellow from "ui/assets/images/GiftYellow.svg";
import GiftRed from "ui/assets/images/GiftRed.svg";
import GiftPurple from "ui/assets/images/GiftPurple.svg";
import { SelectableCardProps } from "ui/common/components/surface/SelectableCard/SelectableCard.types";
import { CategorizedGiftCards, GiftCard } from "ui/giftcards/types/giftcard.types";
import { LocaleTranslationResource } from "ui/locale";

export interface GiftcardsFilter {
    bottomElement?: BottomElement;
    selectableCard: SelectableCardProps;
    filter: (giftCards: CategorizedGiftCards) => CategorizedGiftCards;
}

export type BottomElement = {
    title: LocaleTranslationResource;
    text: LocaleTranslationResource;
};

function giftCardsFilterHelper(giftCards: CategorizedGiftCards, filterFn: (item: GiftCard) => void) {
    const filteredList: CategorizedGiftCards = {};
    const keys = Object.keys(giftCards);
    keys.forEach((key) => {
        const filteredCategory = giftCards[key].filter(filterFn);
        filteredList[key] = filteredCategory;
    });
    return filteredList;
}

export const GIFTCARDS_FILTERS: GiftcardsFilter[] = [
    {
        selectableCard: {
            label: "allGiftCards",
            image: GiftPurple,
            value: "traveling",
        },
        filter: (giftCards: CategorizedGiftCards) => {
            return giftCards;
        },
    },
    {
        selectableCard: {
            label: "noChargedGiftCards",
            image: GiftRed,
            value: "pets",
        },
        bottomElement: {
            title: "noChargedGiftCards",
            text: "noChargedGiftCardsText",
        },
        filter: (giftCards: CategorizedGiftCards) => {
            return giftCardsFilterHelper(giftCards, (item) => !item.isSpecial);
        },
    },
    {
        selectableCard: {
            label: "chargedGiftCards",
            image: GiftYellow,
            value: "technology",
        },
        bottomElement: {
            title: "chargedGiftCards",
            text: "chargedGiftCardsText",
        },
        filter: (giftCards: CategorizedGiftCards) => {
            return giftCardsFilterHelper(giftCards, (item) => item.isSpecial);
        },
    },
];
